import { Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

import { useTheme } from "@mui/styles";
import { useState } from "react";

import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";


const reprocessOptions = [
  'Pumping Data',
  'Monitor Data',
  'Metrics',
  'ISIP',
  'Stepdown',
  'Frac Model',
  'Stage Events',
  'Induced Seismicity Events'
];

export const RTFOReprocessStage = ({ currentRTFO, reprocessStageVisible, setReprocessStageVisible, darkMode }) => {
  
  // const dispatch = useDispatch();
  // const { socket } = useSocket();

  const theme = useTheme();

  const [reprocessType, setReprocessType] = useState('select');
  const [checkedStages, setCheckedStages] = useState([currentRTFO?.currentStageName]);
  const [checkedOptions, setCheckedOptions] = useState(['Pumping Data', 'Frac Model']);
  const [pumpingDataType, setPumpingDataType] = useState('existing');
  const [fracModelType, setFracModelType] = useState('advanced');
  const [optionsType, setOptionsType] = useState('select');

  return (
    <Dialog 
      open={reprocessStageVisible} 
      onClose={() => setReprocessStageVisible(false)}
      maxWidth="sm"
      fullWidth={true}
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
        },
        sx: {boxShadow: 1},
        elevation: 0
      }}
    >
      <DialogTitle>Reprocess Stage</DialogTitle>
      <DialogContent style={{display: 'flex', flexDirection: 'column'}}>
        
        <Typography variant="caption2">Stage(s)</Typography>
        
        <ToggleButtonGroup 
          value={reprocessType} 
          onChange={(e, val) => val && setReprocessType(val)}
          exclusive
          fullWidth
          size="small"
        >
          <ToggleButton value="current" color={(darkMode ? "" : "primary")}>Current</ToggleButton>
          <ToggleButton value="select" color={(darkMode ? "" : "primary")}>Select</ToggleButton>
          <ToggleButton value="all" color={(darkMode ? "" : "primary")}>All</ToggleButton>
        </ToggleButtonGroup>

        {reprocessType === 'select' && <div style={{display: 'flex', flexDirection: 'column', marginTop: 20}}>

          <List dense style={{height: 300, overflowY: 'scroll'}}>
            {[...currentRTFO?.stages]?.reverse()?.map(stageName => {
              return (
                <ListItem key={stageName} style={{margin: 0, padding: 0}}>
                  <ListItemButton role={undefined} onClick={() => handleToggleStage(stageName)} dense>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checkedStages.indexOf(stageName) !== -1}
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText primary={<Typography fontSize={14}>{stageName}</Typography>} />
                  </ListItemButton>
                </ListItem>
              )
            })}
          </List>
        </div>}

        <div style={{display: 'flex', flexDirection: 'column', marginTop: 20}}>
          <Typography variant="caption2">Options to Reprocess</Typography>

          <ToggleButtonGroup 
            value={optionsType} 
            onChange={handleOptionsTypeChange}
            exclusive
            fullWidth
            size="small"
          >
            <ToggleButton value="select" color={(darkMode ? "" : "primary")}>Select</ToggleButton>
            <ToggleButton value="all" color={(darkMode ? "" : "primary")}>All</ToggleButton>
          </ToggleButtonGroup>
          
          {optionsType === 'select' && <div>
            <Typography variant="caption">Reprocess Options</Typography>
            <Divider />
            <List>
              {reprocessOptions?.map(option => {
                return (
                  <Chip
                    icon={optionsType !== 'all' && checkedOptions?.includes(option) ? <CheckCircle /> : <RadioButtonUnchecked />}
                    label={option}
                    color={optionsType !== 'all' && checkedOptions?.includes(option) ? 'primary' : 'default'}
                    style={{margin: 5}}
                    key={option}
                    onClick={() => handleToggleOption(option)}
                    // onDelete={data.label === 'React' ? undefined : handleDelete(data)}
                  />
                )
              })}
              {/* {reprocessOptions?.map(option => {
                return (
                  <ListItem key={option} style={{margin: 0, padding: 0}}>
                    <ListItemButton role={undefined} onClick={() => handleToggleOption(option)} dense>
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={checkedOptions.indexOf(option) !== -1}
                          tabIndex={-1}
                          disableRipple
                        />
                      </ListItemIcon>
                      <ListItemText primary={<Typography fontSize={14}>{option}</Typography>} />
                    </ListItemButton>
                  </ListItem>
                )
              })} */}
            </List>
          </div>}

        </div>

        {checkedOptions?.includes('Pumping Data') && <div style={{display: 'flex', flexDirection: 'column', marginTop: 20}}>
          <Typography variant="caption2">Pumping Data Source</Typography>

          <ToggleButtonGroup 
            value={pumpingDataType} 
            onChange={(e, val) => val && setPumpingDataType(val)}
            exclusive
            fullWidth
            size="small"
          >
            <ToggleButton value="existing" color={(darkMode ? "" : "primary")} title="Use existing pumping data">Existing</ToggleButton>
            <ToggleButton value="api" color={(darkMode ? "" : "primary")} title="Fetch pumping data from data provider's API">API</ToggleButton>
            <ToggleButton value="csv" color={(darkMode ? "" : "primary")} title="Upload CSV pumping data">CSV</ToggleButton>
          </ToggleButtonGroup>
        </div>}

        {checkedOptions?.includes('Frac Model') && <div style={{display: 'flex', flexDirection: 'column', marginTop: 20}}>
          <Typography variant="caption2">Frac Model Type</Typography>

          <ToggleButtonGroup 
            value={fracModelType} 
            onChange={(e, val) => val && setFracModelType(val)}
            exclusive
            fullWidth
            size="small"
          >
            <ToggleButton value="advanced" color={(darkMode ? "" : "primary")} title="Use advanced frac model">Advanced</ToggleButton>
            <ToggleButton value="simplified" color={(darkMode ? "" : "primary")} title="Use simplified frac model">Simplified</ToggleButton>
          </ToggleButtonGroup>
        </div>}

        
      </DialogContent>
      <DialogActions style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
        <Button onClick={() => setReprocessStageVisible(false)} color={darkMode ? "inherit" : "primary"} style={{marginRight: 10}}>
          Cancel
        </Button>
        <Button 
          onClick={() => handleReprocess(checkedStages)} 
          color={darkMode ? "inherit" : "primary"} 
          style={{color: darkMode ? '#000' : '#fff'}} 
          variant="contained"
          disabled={checkedOptions?.length === 0 || checkedStages?.length === 0}
        >
          Reprocess
        </Button>

      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS
  function handleToggleStage(stageName) {

    console.log(checkedStages, stageName)

    if (checkedStages?.includes(stageName)) {
      if (checkedStages?.length === 1) {
        setCheckedStages([]);
      } else {
        setCheckedStages(prev => prev?.length > 0 ? prev?.filter(s => s !== stageName) : []);
      };
    } else {
      setCheckedStages(prev => [...prev, stageName])
    };
  };

  function handleToggleOption(option) {
    if (checkedOptions?.includes(option)) {
      setCheckedOptions(prev => prev.filter(s => s !== option));
    } else {
      setCheckedOptions(prev => [...prev, option])
    };
  };

  function handleOptionsTypeChange(e, newVal) {
    if (!newVal) return;

    setOptionsType(newVal);

    if (newVal === 'all') {
      setCheckedOptions(reprocessOptions);
    } else {
      setCheckedOptions([]);
    };
  };

  function handleReprocess(stageNames, options) {
    return;
  }

  // function formatOption(option) {
  //   const parts = option?.split(' ');

  //   return parts[0]?.toLowerCase()?.concat(parts?.slice(1, )?.join(''))?.trim();
  // }
};